import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#EA580C",
    },
    custom: {
      white: "#ffffff",
      softGrey: "#D6D6D7",
      slateGrey: "#8692A6",
      darkGrey: "#525252",
    },
  },
  typography: {
    color: "#000000",
    fontFamily: ["Roboto", "Inter", "sans-serif"].join(","),

    // Custom typography variant
    auth_h1: {
      fontFamily: "Poppins, Inter, Roboto, sans-serif",
      fontWeight: 700,
      fontSize: "1.75rem",
      color: "#525252",
      lineHeight: 1.2,
      textAlign: "center",
    },
    auth_body1: {
      fontFamily: "Inter, Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      color: "#8692A6",
      lineHeight: 1.2,
      textAlign: "center",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: ["Roboto", "Inter", "sans-serif"].join(","),
          textTransform: "capitalize",
          borderRadius: "10px",
          width: "100%",
          height: "100%",
          boxShadow: "none",
          padding: "10px",
        },
        contained: {
          backgroundColor: "#EA580C",
          color: "#ffffff",
          fontSize: "1rem",
          fontWeight: 600,
          border: "1px solid #EA580C",
          "&:hover": {
            backgroundColor: "#EA580C",
            boxShadow: "none",
          },
        },
        outlined: {
          backgroundColor: "transparent",
          color: "#EA580C",
          fontSize: "0.875rem",
          fontWeight: 400,
          border: "1px solid #A6A9AC",
          "&:hover": {
            backgroundColor: "transparent",
            border: "1px solid #A6A9AC",
            boxShadow: "none",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined", // Default variant
        size: "small", // Default size
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 0,
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #EA580C`,
              boxShadow: "0px 4px 10px 0px #ebebeb",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #EA580C`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid #EA580C`,
            },
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginTop: 0,
          },
          "& .Mui-disabled": {
            cursor: "not-allowed",
          },
        },
      },
    },
  },
});

export default theme;
